import './recorder-selector.sass';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import _isFunction from 'lodash.isfunction';

import Select from 'react-select2-wrapper';
import 'react-select2-wrapper/css/select2.min.css';

import request from 'actions/request';
import transmit from 'actions/transmit';

class RecorderSelector extends Component {
  componentWillMount() {
    if ((typeof this.props.methodHandler === 'object')
      && (this.props.methodHandler.getSelectedRecorderId === null)
    ) {
      this.props.methodHandler.getSelectedRecorderId = this.getSelectedId.bind(this);
    }
  }

  componentDidMount() {
    this.fetchRecordersIfNeeded();
    this.syncChosenRecorder();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.fetchRecordersIfNeeded();
    }
  }

  fetchRecordersIfNeeded(isRetry = false) {
    if (!this.props.isAuthenticated || (this.props.pending !== null && !isRetry)) {
      return;
    }

    this.props.request(
      ['recorders', 'getAll'],
      'get',
      'RECORDERS'
    ).then((resp) => {
      if (!resp || resp.length < 1) {
        return;
      }

      if (_isFunction(this.props.handleChange)) {
        this.props.handleChange(resp[0]);
      }

      this.transmitChooseRecorder(resp[0]);
    }, () => {
      if (!isRetry) {
        this.fetchRecordersIfNeeded(true);
      }
    });
  }

  syncChosenRecorder() {
    if (this.props.pending === null) {
      return;
    }

    if (Number.isInteger(parseInt(this.props.chosenRecorderId))
        && (this.props.chosenRecorderId !== this.props.chosen.id)
    ) {
      let chosenIndex = this.props.recorders.findIndex((item) => {
        return item.id === this.props.chosenRecorderId;
      });

      if (chosenIndex === -1) {
        return;
      }

      if (_isFunction(this.props.handleChange)) {
        this.props.handleChange(this.props.recorders[chosenIndex]);
      }

      this.transmitChooseRecorder(this.props.recorders[chosenIndex]);
    }
  }

  buildList() {
    if (!this.props.recorders || this.props.recorders.length === 0) {
      return [];
    }

    return this.props.recorders.map((item) => {
      return {
        text: item.name,
        id: item.id
      };
    });
  }

  handleSelect() {
    if (!this.selectRecorderType.el[0]) {
      return;
    }

    let el = this.selectRecorderType.el[0];
    let val = parseInt(el.options[el.selectedIndex].value);

    let index = this.props.recorders.findIndex((item) => {
      return item.id === val;
    });

    if (index === -1) {
      return;
    }

    let chosen = this.props.recorders[index];

    if (_isFunction(this.props.handleChange)) {
      this.props.handleChange(chosen);
    }

    this.transmitChooseRecorder(chosen);
  }

  transmitChooseRecorder(chosen) {
    this.props.transmit('CHOOSE_RECORDER', chosen)
      .then(() => {
        this.props.transmit('CLEAR_RECORDER_TEMPLATES');
        this.props.transmit('SET_CHOSEN_CALIBRATION', {
          chosen: chosen.calibrations[0] || null
        });
      });
  }

  getSelectedId() {
    return this.props.chosen.id;
  }

  render() {
    let isHidden = true;

    if (this.props.recorders
      && (this.props.recorders.length > 0)
      && (this.props.chosen)
    ) {
      isHidden = false;
    }

    let chosen = this.props.chosenRecorderId || this.props.chosen.id || null;
    let allowClear = false;
    if (this.props.isClear) {
      chosen = null;
      allowClear = true;
    }

    return (
      <li className={ 'recorder-selector ' + (isHidden ? 'is-hidden' : '') }>
        <a href='#'><Select
          className='recorder-selector__select'
          data={ this.buildList() }
          disabled={ (this.props.disabled === true) }
          value={ chosen }
          onSelect={ this.handleSelect.bind(this) }
          ref={(select) => { this.selectRecorderType = select; }}
          options={{
            placeholder: I18n.t('recorderSelector.placeholder'),
            allowClear: allowClear
          }}
        />
        </a>
      </li>
    );
  }
}

RecorderSelector.propTypes = {
  isClear: PropTypes.bool,
  chosenRecorderId: PropTypes.number,
  handleChange: PropTypes.func,
  methodHandler: PropTypes.object,
  disabled: PropTypes.bool,

  pending:  PropTypes.bool,
  recorders: PropTypes.array,
  chosen: PropTypes.object,

  request: PropTypes.func,
  transmit: PropTypes.func
};

function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.login !== null,
    pending: state.recorders.pending,
    recorders: state.recorders.items,
    chosen: state.recorders.chosen
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecorderSelector);
